import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActiveSectionStateService {
  state!: string;
  private eventSource = new Subject<any>();
  event$ = this.eventSource.asObservable();
  constructor() {}

  setState(id: string) {
    this.state = id;
  }

  getState(): string {
    return this.state;
  }

  emit(event: any) {
    // console.log(event);
    this.eventSource.next(event);
  }
}
